export default "__VITE_ASSET__CU7zs7Kz__"